import { render, staticRenderFns } from "./PortfolioWorks.vue?vue&type=template&id=e5ea6196&"
import script from "./PortfolioWorks.vue?vue&type=script&lang=js&"
export * from "./PortfolioWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports